import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: ${spacing.xl}px 0 ${spacing.xxxxl}px;
  ${mediaQuery(
    {
      max: maxBreakpoints.M,
    },
    css`
      margin-top: ${spacing.md}px;
    `,
  )}
`;

export const container = css`
  max-width: 960px;
  padding: 0 ${spacing.md}px;
  margin: 0 auto;
  min-height: 300px;
  &[data-no-padding='true'] {
    padding: 0;
  }
  &[data-wide='true'] {
    max-width: 1070px;
  }
`;

export const title = css`
  margin: ${spacing.xxl}px 0 ${spacing.xl}px 0;
  text-align: center;
`;

export const copy = css`
  ${theme.responsiveText.HEADING.XS}
  margin: 0 0 ${spacing.xxxl}px 0;
  text-align: center;

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      margin: 0 0 52px 0;
    `,
  )}
`;
